var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"modal-page-container"}},[_c('VDialog',{attrs:{"transition":"translateX","attach":"#modal-page-container","value":_vm.show,"persistent":true},on:{"click:outside":_vm.closingFromOutsideClick}},[_c('router-view',{on:{"close":_vm.closingFromEmitted}}),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }